import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactGA from 'react-ga';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'

const externalClick = (action) => {
    // ReactGA.event({
    //     category: 'external links',
    //     action: action
    // });
}

const clickHandler = (e, action, handler) => {
    // ReactGA.event({
    //     category: 'navigation',
    //     action: `click ${action}`
    // });
    if (handler) {
      handler(e);
    }
}

const NavLinkComponent = props => {

  if (!props.nonEvent) {
    return (
      <li className={props.styles.listItem}>
        {props.btn.link && !props.btn.external && (
          <NavLink
            exact
            to={props.btn.link}
            className={props.styles.btn}
            onClick={(e) => clickHandler(e, props.title, props.menuHandler)}
            title={props.title}
          >
            <FontAwesomeIcon icon={props.btn.icon} size="2x" />
            <span className={props.styles.title}>{props.title}</span>
          </NavLink>
        )}
        {props.btn.link && props.btn.external && (
          <a href={props.btn.link} className={props.styles.btn} onClick={() => externalClick(props.title)}>
            <FontAwesomeIcon icon={props.btn.icon} size="2x" />
            <span className={props.styles.title}>{props.title}</span>
          </a>
        )}
        {props.children}
      </li>
    );
  } else {
    return (
      <li className={props.styles.listItem}>
        {props.btn.link && (
          <div onClick={props.openSubMenu} className={props.styles.btn} title={props.openName}>
            <FontAwesomeIcon icon={props.btn.icon} size="2x" />
            <span className={props.styles.title}>{props.title}</span>
            {props.extended && <FontAwesomeIcon icon={ props.open ? faAngleUp : faAngleDown} />}
          </div>
        )}
        {props.children}
      </li>
    );
  }
};

export default NavLinkComponent;
